
// 机场设置
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useRef, useEffect } from 'react'
import { Card, theme, Button, Table, Dropdown, Popconfirm, Drawer, Input, Form, Space, message, InputNumber } from 'antd'
import { PlusOutlined, MenuOutlined, SyncOutlined, QuestionCircleOutlined, EditOutlined, PoweroffOutlined, DeleteOutlined, LoadingOutlined, InfoCircleOutlined } from '@ant-design/icons'
import dayjs from 'dayjs';
import { getAirPortListAPI, delAirPortListAPI, setAirPortListAPI, verifyAirPortSnAPI, restartDockAPI } from '@/server/airportSettings.js'
import { getWebSocketAddress } from '@/server/commandFlight.js'

function AirportSet () {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const { token: { colorTextPlaceholder, colorText } } = theme.useToken(); //获取主题颜色

  const ws = useRef(null);
  const [drawerForm] = Form.useForm()
  const token = localStorage.getItem('dock_token')
  const [loading, setLoading] = useState(false)//加载中···
  const [tableData, setTableData] = useState([])//table数据

  const [drawerEditList, setDrawerEditList] = useState({//编辑信息  抽屉
    title: '',
    id: undefined,
    open: false,
    wsLoading: false,//获取ws的等待
    subLoading: false,//提交等待
  })

  const getData = async () => {//获取主要数据
    setLoading(true)
    let res = await getAirPortListAPI({ access_token: token })
    setLoading(false);
    if (res.ret !== 200) { message.warning(res.msg); return }
    setTableData(res.data)
  }

  const getLonLatByWs = async () => { //通过机场编号获取经纬度
    let date = null
    let dra = drawerEditList
    if (drawerForm.getFieldValue('dockSn')) {
      let isShow = await verifyAirPortSnAPI({ access_token: token, dockSn: drawerForm.getFieldValue('dockSn') })
      if (isShow.ret !== 200) {
        message.warning(isShow.msg || '')
        return
      }
      if (isShow.data) {
        console.log('进来了');
        dra.wsLoading = true
        if (ws.current) { ws.current.close(); ws.current = null }

        let res = await getWebSocketAddress({ access_token: token, type: 1 })//获取ws地址
        if (res.ret !== 200) {
          message.warning(res.msg);
          dra.wsLoading = false
          setDrawerEditList({ ...dra })
          return
        }

        ws.current = new WebSocket(res.data);
        ws.current.onopen = (msg) => {//链接开启
          console.log("链接成功", msg);
          date = dayjs().valueOf()
          console.log('data', date);
        };

        ws.current.onmessage = e => {// 成功获取数据
          try {
            let data = JSON.parse(e.data)
            if ((dayjs().valueOf() - date) > 1000 * 5) {
              ws.current.close();
              ws.current = null
              message.warning('获取超时');
              dra.wsLoading = false
              setDrawerEditList({ ...dra })
            }

            if (data.biz_code === 'dock_osd' && data.data.sn === drawerForm.getFieldValue('dockSn')) {//机场
              console.log('机场数据：', data.data);
              if (data.data.host.latitude) {
                drawerForm.setFieldsValue({
                  latitude: data.data.host.latitude,
                  longitude: data.data.host.longitude,
                })
                message.success('重新获取成功');
                ws.current.close();
                ws.current = null
                dra.wsLoading = false
                setDrawerEditList({ ...dra })
              }

            }
          } catch (error) {
            // message.warning('当前机场状态错误，请确认机场是否正确链接')
          }
        }

        ws.current.onerror = (msg) => {//报错信息
          // console.log('链接出错', msg)
        }

        ws.current.onclose = (msg) => {//链接断开
          console.log('链接断开', msg)

        };

        setDrawerEditList({ ...dra })
      } else {
        message.warning(isShow.msg || '当前机场编号不正确')
      }
    } else {
      message.warning('机场编号不存在')
    }

  }

  const onFinish = async (data) => {//提交表单数据
    let dra = drawerEditList
    dra.subLoading = true
    setDrawerEditList({ ...dra })
    let obj = {
      access_token: token,
      id: drawerEditList.id || undefined,
      dockName: data.dockName || undefined,
      dockSn: data.dockSn,
      longitude: data.longitude,
      latitude: data.latitude,
      radius: data.radius * 1000 || undefined,
    }
    let res = await setAirPortListAPI(obj)
    if (res.ret !== 200) {
      message.warning(res.msg);
      dra.subLoading = false
      setDrawerEditList({ ...dra })
      return
    }
    dra.title = ''
    dra.open = false
    dra.subLoading = false
    setDrawerEditList({ ...dra })
    message.success(data.dockName ? '修改成功' : '新增成功')
    getData()
  }

  const columns = [
    {
      title: '机场名称',
      dataIndex: 'dockName',
      render: (text, record) => {
        return (
          text
            ? <div className='opa85'>{text}</div>
            : <div className='opa25'>-</div>
        )
      },
    },
    {
      title: '机场编号',
      dataIndex: 'dockSn',
      render: (text, record) => {
        return (
          text
            ? <div>{text}</div>
            : <div className='opa25'>-</div>
        )
      },
    },
    {
      title: '经度',
      dataIndex: 'lon',
      render: (text, record) => {
        return (
          text
            ? <div className='opa85'>{text}</div>
            : <div className='opa25'>-</div>
        )
      },
    },
    {
      title: '维度',
      dataIndex: 'lat',
      render: (text, record) => {
        return (
          text
            ? <div className='opa85'>{text}</div>
            : <div className='opa25'>-</div>
        )
      },
    },
    {
      title: '半径(km)',
      dataIndex: 'radius',
      render: (text, record) => {
        return (
          text
            ? <div className='opa85'>{text / 1000}</div>
            : <div className='opa25'>-</div>
        )
      },
    },
    {
      title: '无人机编号',
      dataIndex: 'aircraftSn',
      render: (text, record) => {
        return (
          text
            ? <div className='opa85'>{text}</div>
            : <div className='opa25'>-</div>
        )
      },
    },
    {
      title: '编辑人',
      dataIndex: 'username',
      render: (text, record) => {
        return (
          text
            ? <span className='opa45'>{text}</span>
            : <div className='opa25'>-</div>
        )
      },
    },
    {
      title: '编辑时间',
      dataIndex: 'time',
      render: (text, record) => {
        return (
          text
            ? (
              <div>
                <span className='opa45 marR8'>{text.substring(0, 10)}</span>
                <span className='opa45'>{text.substring(11, 16)}</span>
              </div>
            )
            : <div className='opa25'>-</div>
        )
      },
    },
    {
      title: '操作',
      dataIndex: '',
      align: 'center',
      width: 80,
      render: (text, record) => {
        return (
          <Dropdown
            trigger={['click']}
            menu={dropDownOption(record)}
            placement="bottom"
          >
            <MenuOutlined className='pointer col_primary' />
          </Dropdown>
        )
      }
    },
  ]

  //表格操作列表
  const dropDownOption = (data) => {
    const typeArr = [
      {
        icon: <PoweroffOutlined />,
        label: (
          <Popconfirm
            title="确定重启机场？"
            icon={<QuestionCircleOutlined style={{ color: 'red', }} />}
            onConfirm={async () => {
              let restartDockArr = JSON.parse(localStorage.getItem('dock_restartDockArr')) || []
              let res = await restartDockAPI({ access_token: token, sn: data.dockSn })
              if (res.ret !== 200) { message.warning(res.msg); return }
              if (restartDockArr.find(ele => ele.dockId === data.dockId)?.dockId) {
                restartDockArr.find(ele => ele.dockId === data.dockId).time = dayjs().valueOf()
              } else {
                restartDockArr.push({ dockId: data.id, time: dayjs().valueOf() })
              }
              localStorage.setItem('dock_restartDockArr', JSON.stringify(restartDockArr))
              message.success('重启机场成功')
            }}
            onCancel={() => { }}
            okText="重启"
            cancelText="取消"
          >
            重启
          </Popconfirm>
        ),
      },
      { type: 'divider' },
      {
        icon: <EditOutlined />,
        label: (
          <div
            onClick={() => {
              drawerForm.resetFields()
              drawerForm.setFieldsValue({
                dockSn: data.dockSn || undefined,
                dockName: data.dockName || undefined,
                longitude: data.lon || undefined,
                latitude: data.lat || undefined,
                radius: data.radius / 1000 || undefined,
              })
              let dra = drawerEditList
              dra.id = data.id
              dra.open = true
              dra.title = '修改'
              setDrawerEditList({ ...dra })
            }}
          >
            修改
          </div>
        ),
      },
      {
        icon: <DeleteOutlined />,
        label: (
          <div>
            <Popconfirm
              title="是否删除？"
              icon={<QuestionCircleOutlined style={{ color: 'red', }} />}
              onConfirm={async () => {
                let res = await delAirPortListAPI({ access_token: token, id: data.id, status: 0 });
                if (res.ret !== 200) { message.warning(res.msg); return }
                getData()
              }}
              onCancel={() => { }}
              okText="删除"
              cancelText="取消"
            >
              删除
            </Popconfirm>
          </div>
        ),
      },
    ]
    return { items: typeArr }
  }

  useEffect(() => {
    getData()

    // eslint-disable-next-line
  }, [])

  return (
    <Card className='mar24' style={{ border: 0 }}>

      <>{/* 头部 */}
        <div className="flex jcr pdRL12 pdB16 align_center">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              drawerForm.resetFields()
              let dra = drawerEditList
              dra.id = undefined
              dra.open = true
              dra.title = '新增'
              setDrawerEditList({ ...dra })
            }}
          >
            新增
          </Button>
        </div>
      </>

      <>{/* 表格 */}
        <Table
          rowKey='id'
          columns={columns}
          dataSource={tableData}
          loading={loading}
        />
      </>

      <>{/* 页脚 */}
      </>

      <>{/* 组件集 */}
        <>
          {/* 新增||修改  列表 */}
        </>
        <Drawer
          title={drawerEditList.title}
          open={drawerEditList.open}
          width={256}
          footer={null}
          maskClosable={false}
          onClose={() => {
            if (ws.current) { ws.current.close(); ws.current = null }
            drawerForm.resetFields()
            let dra = drawerEditList
            dra.id = undefined
            dra.title = ''
            dra.open = false
            dra.wsLoading = false
            setDrawerEditList({ ...dra })
          }}
          extra={
            <Button
              type='primary'
              loading={drawerEditList.subLoading}
              disabled={drawerEditList.wsLoading}
              onClick={() => { drawerForm.submit() }}
            >
              提交
            </Button>
          }
        >
          <Form
            form={drawerForm}
            layout="vertical"
            onFinish={onFinish}
            style={{ marginTop: '12px' }}
          >
            <Form.Item
              name="dockSn"
              label="机场编号"
              rules={[{ required: true, },]}
            >
              <Input placeholder="-" allowClear disabled={drawerEditList.title === '修改'} />
            </Form.Item>

            <Form.Item
              name="dockName"
              label="机场名称"
              rules={[{ required: true, },]}
            >
              <Input placeholder="-" allowClear />
            </Form.Item>

            <Space className='flex '>
              <Form.Item
                name="longitude"
                label="经度"
                rules={[{ required: true, },]}
                tooltip={{
                  title: '仅支持WGS84坐标',
                  icon: <InfoCircleOutlined />,
                }}
              >
                <Input placeholder="-" allowClear />
              </Form.Item>
              <Button
                className='marT6'
                disabled={drawerEditList.wsLoading}
                onClick={() => { getLonLatByWs() }}
                icon={drawerEditList.wsLoading ? <LoadingOutlined /> : <SyncOutlined />}
              />
            </Space>

            <Space >
              <Form.Item
                name="latitude"
                label="纬度"
                rules={[{ required: true, }]}
                tooltip={{
                  title: '仅支持WGS84坐标',
                  icon: <InfoCircleOutlined />,
                }}
              >
                <Input placeholder="-" allowClear />
              </Form.Item>
              <Button
                className='marT6'
                disabled={drawerEditList.wsLoading}
                onClick={() => { getLonLatByWs() }}
                icon={drawerEditList.wsLoading ? <LoadingOutlined /> : <SyncOutlined />}
              />
            </Space>

            {
              drawerEditList.title === '修改' &&
              <Form.Item
                name="radius"
                label="半径(km)"
                rules={[{ required: true, },]}
              >
                <InputNumber
                  min={0.5}
                  step={0.1}
                  max={15}
                  placeholder="-"
                  className='wid100'
                />
              </Form.Item>
            }
          </Form>
        </Drawer>
      </>

    </Card >
  )
}
export default AirportSet;